'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"date-picker__dash":"date-picker-module_date-picker__dash__y5K2g","date-picker":"date-picker-module_date-picker__slFy1","input-wrapper":"date-picker-module_input-wrapper__ZyzVQ","datepicker__icon":"date-picker-module_datepicker__icon__D79tU","date-range-picker":"date-picker-module_date-range-picker__9GJwC","date-picker__input":"date-picker-module_date-picker__input__lslEr","invalid":"date-picker-module_invalid__HatjK","date-picker__label":"date-picker-module_date-picker__label__nPqZa","date-picker__help-text":"date-picker-module_date-picker__help-text__5yHJZ"};

exports.default = styles;
//# sourceMappingURL=date-picker.module.scss.js.map
